/**
 * « Karim écrit… », as Maude validated it on 31/10/2026 (« Ton mélange »):
 * the name under the conversation's title and three dots where the next
 * message will appear.
 *
 * Nothing is stored. The app says « I am typing » at most every
 * TYPING_SAID_EVERY_MS while the box holds words, the API passes it to the
 * rest of the conversation, and a screen forgets it TYPING_FORGOTTEN_AFTER_MS
 * after the last one, or as soon as that person's message arrives. A phone
 * that loses its network therefore stops « typing » on its own, and no « I
 * stopped » signal is needed, which is one fewer event that can go missing.
 *
 * Shared by the API, which drops signals that come faster, and the app.
 */

export const SayTyping = 'say-typing';
export const SomeoneTyping = 'someone-typing';
export const SomeoneTypingIn = (chatId: string) => `${SomeoneTyping}-${chatId}`;

/** How often the app repeats « I am typing » while the box holds words. */
export const TYPING_SAID_EVERY_MS = 3_000;
/** How long a screen keeps showing somebody typing after their last signal. */
export const TYPING_FORGOTTEN_AFTER_MS = 6_000;

export interface SayTypingRequest {
  chatId: string;
}

export interface SomeoneTypingEvent {
  chatId: string;
  userId: string;
  /** The first name, as the header says it: « Karim écrit… ». */
  name: string;
}
